<script>
export default {
// 生命周期结束调获取列表
  mounted() {
    this.goLink()
  },
  methods: {
    gotoRoute(name) {
      this.$router.push({ name })
    },
    goLink(){
        //window.location.href="http://uc.office.jinmajia.com";
        window.location.href="http://223.0.12.32:8081";
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/carData/addItem.vue